import ReactDOM from "react-dom/client";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Layout from "./layouts/Layout.js";
import LayoutPrint from "./layouts/LayoutPrint.js";
import LayoutTimesheet from "./layouts/LayoutTimesheet.js";
import Customer from "./components/customer/Customers";
import Service from "./components/service/Service";
import Address from "./components/address/Address";
import MyRoutes from "./components/routes/MyRoutes";
import Extra from "./components/extra/Extra";
import Invoices from "./components/invoices/Invoices";
import Projetos from "./components/projetos/Projetos";
import NoPage from "./components/NoPage";
import Login from "./components/Login";
import ImageLogin from "./components/tasks/ImageLogin.js";
import './index.css';
import Home from "./components/home/Home";
import './components/Interceptor2.js';
import Invoice from "./components/invoices/Invoice.js";
import RouteInterceptor from "./components/RouteInterceptor"; // Importa o RouteInterceptor
import TimeTrackingApp from "./components/timesheet/TimeTrackingApp.jsx";
import TimesheetResumo from "./components/timesheet/TimesheetResumo.jsx";
import TimesheetBiweekly from "./components/timesheet/TimesheetBiweekly.jsx";
import ExtraServiceDetails from "./components/extra/ExtraServiceDetails.jsx";
import ExtraServiceList from "./components/extra/ExtraServiceList.jsx";
import ExtraService from "./components/extra/ExtraService.jsx";
import UserNavigation from "./components/timesheet/UserNavigation.jsx";
import ExtraServiceCustomer from "./components/extra/ExtraServiceCustomer.jsx";
import Agenda from "./components/tasks/Agenda.js";
import Dashboard from "./components/tasks/Dashboard";
import Blockings from "./components/tasks/Blockings";
import ToothbrushTimer from "./ToothbrushTimer.jsx";
import LayoutBasic from "./layouts/LayoutBasic.js";
import BeforeAfter from "./components/before-after/BeforeAfter.jsx";

export default function App() {
  return (
    <BrowserRouter>
      <RouteInterceptor />
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<Login />} />
          <Route path="*" element={<NoPage />} />
          <Route path="login" element={<Login />} />
          <Route path="clientes" element={<Customer />} />
          <Route path="services" element={<Service />} />
          <Route path="address" element={<Address />} />
          <Route path="Routes" element={<MyRoutes />} />
          <Route path="invoices" element={<Invoices />} />
          <Route path="projetos" element={<Projetos />} />
          <Route path="extra" element={<Extra />} />
          <Route path="home" element={<Home />} />
          <Route path="print" element={<Home />} />
        </Route>
        <Route path="/print" element={<LayoutPrint />}>
          <Route index element={<Invoice />} />
        </Route>
        <Route path="/timesheet" element={<LayoutTimesheet />} >
          <Route path="removed/:year/:month/:userId" element={<TimeTrackingApp />} />
          <Route path="removed/:year/:month/:userId/print" element={<TimesheetResumo />} />
          <Route path="first-half/:year/:month/:userId" element={<TimesheetBiweekly tipo="first" />} />
          <Route path="second-half/:year/:month/:userId" element={<TimesheetBiweekly tipo="second" />} />
          <Route path="time-tracking" element={<UserNavigation />} />
        </Route>
        <Route path="/extraService-list" element={<ExtraServiceList />} />
        <Route path="/extraService-details" element={<ExtraServiceDetails />} />
        <Route path="/extraService-new" element={<ExtraService />} />
        <Route path="/extraService-edit" element={<ExtraService />} />
        <Route path="/extraService-customer" element={<ExtraServiceCustomer />} />
        <Route path="/apps" element={<LayoutBasic />}>
          <Route path="escovar-dente" element={<ToothbrushTimer/>} /> 
          <Route path="agenda" element={<Agenda />} />  
          <Route path="dashboard" element={<Dashboard />} />
          <Route path="blockings" element={<Blockings />} />
          <Route path="login-images" element={<ImageLogin />} />
          <Route path="before-after" element={<BeforeAfter  />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(<App />);